import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
function currentStatus(title) {
  const match = String(title || '').match(/^\[(Terminé|Vendu|Résolu)\]\s*/i);
  if (!match) return null;
  const value = match[1].toLocaleLowerCase('fr');
  if (value === 'terminé') return 'finished';
  if (value === 'vendu') return 'sold';
  if (value === 'résolu') return 'resolved';
  return null;
}
async function setStatus(discussion, status) {
  try {
    const result = await app.request({
      method: 'POST',
      url: `${app.forum.attribute('apiUrl')}/val/ui/discussions/status`,
      body: {
        discussion_id: Number(discussion.id()),
        status
      }
    });
    if (result && result.title) {
      discussion.pushAttributes({
        title: result.title
      });
      m.redraw();
    }
  } catch (error) {
    const message = error && error.response && error.response.errors && error.response.errors[0] && error.response.errors[0].detail ? error.response.errors[0].detail : 'Impossible de modifier le statut de cette discussion.';
    app.alerts.show({
      type: 'error'
    }, message);
  }
}
app.initializers.add('val-ui-discussion-status', () => {
  extend(DiscussionControls, 'userControls', function (items, discussion, context) {
    if (!(context instanceof DiscussionPage)) return;
    if (!app.session.user) return;

    /*
     * Les discussions privées Byobu ne sont pas concernées.
     * Le serveur refait systématiquement ce contrôle.
     */
    if (typeof discussion.attribute === 'function' && discussion.attribute('isPrivate')) {
      return;
    }
    const author = discussion.user();
    const isAuthor = author && String(author.id()) === String(app.session.user.id());
    const canRename = typeof discussion.canRename === 'function' && discussion.canRename();
    if (!isAuthor && !canRename) return;
    const status = currentStatus(discussion.title());

    /*
     * Premier élément du SplitDropdown :
     * il devient le bouton principal et n'apparaît pas dans le menu.
     */
    items.add('val-actions-trigger', Button.component({
      icon: 'fas fa-ellipsis-h',
      onclick: event => {
        const toggle = event.currentTarget.nextElementSibling;
        if (toggle) {
          toggle.click();
        }
      }
    }, 'Actions'), 100);
    items.add('val-status-finished', Button.component({
      icon: 'fas fa-check',
      title: 'Marquer la discussion comme terminée',
      onclick: () => setStatus(discussion, 'finished')
    }, 'Marquer [Terminé]'), 15);
    items.add('val-status-sold', Button.component({
      icon: 'fas fa-tag',
      title: 'Marquer la discussion comme vendue',
      onclick: () => setStatus(discussion, 'sold')
    }, 'Marquer [Vendu]'), 14);
    items.add('val-status-resolved', Button.component({
      icon: 'fas fa-check-circle',
      title: 'Marquer la discussion comme résolue',
      onclick: () => setStatus(discussion, 'resolved')
    }, 'Marquer [Résolu]'), 13);
    if (status) {
      items.add('val-status-clear', Button.component({
        icon: 'fas fa-undo',
        onclick: () => setStatus(discussion, 'clear')
      }, 'Retirer le statut'), 12);
    }
  });
});